import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';
import { isFunction } from 'lodash';
import classNames from 'classnames';

const AddRemoveButtons = ({
  className,
  iconSize = 18,
  index,
  length,
  customHideRemoveButton,
  onAddClick,
  onRemoveClick,
  color,
}) => {
  const hideAddButton = count => index !== count - 1;

  const hideRemoveButton = (count) => {
    if (isFunction(customHideRemoveButton)) {
      return customHideRemoveButton();
    }
    return index === 0 && count <= 1;
  };

  const containerClasses = classNames('flex', className);
  return (
    <div className={containerClasses}>
      {!hideRemoveButton(length) && (
        <button
          onClick={() => onRemoveClick(index)}
          type="button"
          tabIndex="0"
          title="Remove"
          className={`cursor-pointer flex items-center ${!hideAddButton(length) ? 'mr-1' : ''}`}
        >
          <Icon icon="MinusCircle" size={iconSize} color={color} />
        </button>
      )}
      {!hideAddButton(length) && (
        <button
          onClick={() => onAddClick(index)}
          type="button"
          tabIndex="0"
          title="Add"
          className="cursor-pointer flex items-center"
        >
          <Icon icon="Add" size={iconSize} color={color} />
        </button>
      )}
    </div>
  );
};

AddRemoveButtons.propTypes = {
  className: PropTypes.string,
  customHideRemoveButton: PropTypes.func,
  onAddClick: PropTypes.func.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  iconSize: PropTypes.number,
  index: PropTypes.number.isRequired,
  length: PropTypes.number.isRequired,
  color: PropTypes.string,
};

AddRemoveButtons.defaultProps = {
  className: '',
  customHideRemoveButton: undefined,
  iconSize: 18,
  color: 'brand-blue',
};

export default AddRemoveButtons;
